import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

/**
 * Persistent badge shown in the AI chat / interview UI to indicate that
 * the user is interacting with an AI system. EU AI Act Article 50
 * transparency obligation (effective August 2026).
 */
export default function AIDisclosureBadge() {
  return (
    <Link
      to="/ai"
      target="_blank"
      title="AI-generated responses — learn more"
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-orange-50 border border-orange-200 text-[11px] font-semibold text-orange-700 hover:bg-orange-100 transition-colors"
    >
      <Sparkles className="w-3 h-3" aria-hidden="true" />
      AI-powered · Practice mode
    </Link>
  );
}
